import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CustomvalidationService } from 'src/app/middleware/common/resuableServices/validatorServices';
import { ResetPasswordReqVM } from 'src/app/viewModels/resetPassword/reset-password-req-vm';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { Constants } from 'src/app/middleware/common/reusableclassesAndFunctions/constants';
import { CommonService } from 'src/app/middleware/common/common.service';
import * as jwt_decode from 'jwt-decode';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {

  constructor(private _formBuilder: FormBuilder, private customValidator: CustomvalidationService,
    private resetPasswordVM: ResetPasswordReqVM, private statusConst: StatusConstant,
    private encryptionAlgo: EncryptionService, private reusableClass: ReusableClasses,
    private loaderService: LoaderService, private toastr: ToastrService, private router: Router,
    private constant: Constants, private commonService: CommonService) { }


  resetPasswordForm: FormGroup;
  hidenew = true;
  hideold = true;
  resetPasswordResponseHolder: any;


  ngOnInit(): void {
    this.resetPasswordForm = this._formBuilder.group({
      newPassword: ['', [Validators.required]],
      oldPassword: ['', Validators.required]
    });
  }

  // Get Errors for password field
  getErrorPassword() {
    return this.customValidator.getErrorPassword(this.resetPasswordForm);
  }

  // // To match password on confirm password input box
  // matchPassword(): void {
  //   if (this.resetPasswordForm.controls['newPassword'].value !== this.resetPasswordForm.controls['oldPassword'].value) {
  //     this.resetPasswordForm.controls['oldPassword'].setErrors({ MatchPassword: true });
  //   } else {
  //     return null;
  //   }
  // }


  resetPassword(resetPasswordDetails){
    if (resetPasswordDetails!= undefined) {
      let copyModel = Object.assign(this.resetPasswordVM, {});
      copyModel.newPassword = resetPasswordDetails.value.newPassword;
      copyModel.oldPassword = resetPasswordDetails.value.oldPassword;
      let currentUserToken = sessionStorage.getItem('userToken');
      let decryptedToken = this.encryptionAlgo.get(this.reusableClass.encryptionKey, currentUserToken);
      let currentUser = jwt_decode(decryptedToken);
      copyModel.uuid = currentUser.UID;
      copyModel.newPassword = this.encryptionAlgo.set(this.reusableClass.encryptionKey, copyModel.newPassword);
      copyModel.oldPassword = this.encryptionAlgo.set(this.reusableClass.encryptionKey, copyModel.oldPassword);
      this.resetPasswordVM = copyModel;   
      this.commonService.resetPassword(this.resetPasswordVM).subscribe(response=>{
        if (response) {
          this.resetPasswordResponseHolder = response;
        }
      });
    }
  }

}
